import {
  Badge,
  Button,
  Card,
  Chip,
  createTheme,
  Input,
  Modal,
} from "@mantine/core";

export const ShapesTheme = createTheme({
  radius: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    full: "9999px",
  },
  shadows: {
    xs: "0 1px 2px rgba(9,12,17,.04)",
    sm: "0 1px 2px rgba(9,12,17,.04), 0 2px 6px rgba(9,12,17,.05)",
    md: "0 2px 6px rgba(9,12,17,.04), 0 8px 20px rgba(9,12,17,.06)",
    lg: "0 6px 12px rgba(9,12,17,.04), 0 20px 48px rgba(9,12,17,.08)",
    focus: "0 0 0 3px rgba(43,66,150,0.2)",
  },
  components: {
    Button: Button.extend({
      defaultProps: {
        radius: "sm",
      },
    }),
    Input: Input.extend({
      defaultProps: {
        radius: "sm",
      },
    }),
    Card: Card.extend({
      defaultProps: {
        radius: "lg",
        shadow: "sm",
      },
    }),
    Modal: Modal.extend({
      defaultProps: {
        radius: "xl",
        shadow: "lg",
      },
    }),
    Badge: Badge.extend({
      defaultProps: {
        radius: "full",
      },
    }),
    Chip: Chip.extend({
      defaultProps: {
        radius: "full",
      },
    }),
  },
});
